interface StatInfoCardProps {
  label: string;
  value: string;
  icon: string;
}

export function StatInfoCard({ label, value, icon }: StatInfoCardProps) {
  return (
    <div className="flex flex-col gap-1.5 rounded-3xl bg-black/5 dark:bg-white/5 p-4 border border-black/10 dark:border-white/10">
      <div className="flex items-center gap-2 text-content-light/70 dark:text-content-dark/70">
        <span className="material-symbols-outlined text-base">{icon}</span>
        <p className="text-sm font-medium">{label}</p>
      </div>
      <p className="tracking-light text-2xl font-bold leading-tight text-content-light dark:text-content-dark">
        {value}
      </p>
    </div>
  );
}
